import React from 'react';
import LoadingAsyncTask from 'components/loading/async-task';
import api from 'services/api';

export default function AsyncAppStatus({ installedApp, onCompleted }) {
  return (
    <LoadingAsyncTask
      record={installedApp}
      onCompleted={onCompleted}
      endpoint="client/app-async-status"
      tasks={[
        { type: 'install', label: 'Installing' },
        { type: 'update', label: 'Updating' },
        { type: 'uninstall', label: 'Uninstalling' },
      ]}
      onCheckStatus={onCheckStatus}
    />
  );
}

async function onCheckStatus(record) {
  return api.get(`/client/app-async-status/${record?.app_id}`);
}
